import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import {
    ArticleScanAutocompleteComponent,
    ArticleScanSelectedEvent,
} from '../../../components/article-scan-autocomplete/article-scan-autocomplete.component';
import { KieneAutocompleteComponent } from '../../../components/kiene-autocomplete/kiene-autocomplete.component';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { FileUploadService } from '../../../dialogs/file-upload-dialog/file-upload.service';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Material } from '../../../warehouse/material/material';
import { Antibiogramm, Pruefer } from '../../antibiogramm/antibiogramm';
import { Befundmitteilung, BefundmitteilungExtern, BefundmitteilungPosition } from '../befundmitteilung';
import { BefundmitteilungService } from '../befundmitteilung.service';
import { IdexxResultDialogComponent } from '../idexx-result-dialog/idexx-result-dialog.component';
import {
    PreisAnpassungDialogComponent,
    PreisAnpassungInput,
    PreisAnpassungResult,
} from '../preis-anpassung-dialog/preis-anpassung-dialog.component';
import { ExterneBefundeDialogComponent } from './externe-befunde-dialog/externe-befunde-dialog.component';
import { SelectBefundKategorieDialogComponent } from '../select-befund-kategorie-dialog/select-befund-kategorie-dialog.component';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';

@Component({
    selector: 'kiene-detailsseite',
    templateUrl: './detailsseite.component.html',
    styleUrls: ['./detailsseite.component.css'],
})
export class DetailsseiteComponent implements OnInit, OnDestroy {
    @ViewChild('articleScan') articleScan: ArticleScanAutocompleteComponent;
    @ViewChild('gruppeAutocomplete')
    gruppeAutocomplete: KieneAutocompleteComponent;

    befundmitteilung: Befundmitteilung;
    befundmitteilungenExtern: BefundmitteilungExtern[] = [];

    currentGruppe: Gruppe;

    currentEditPosition = -1;

    kategorie: string;
    kategorien = ['E', 'S', 'B', 'M', 'PF', 'FB'];

    antibiogramme: Antibiogramm[] = [];
    antibiogrammCtrl = new FormControl();

    // tagebuchCtrl = new UntypedFormControl();
    probenentnahmeCtrl = new FormControl();
    untersuchungsbeginnCtrl = new FormControl();
    untersuchungsendeCtrl = new FormControl();
    untersuchungsmaterialCtrl = new FormControl();
    prueferCtrl = new FormControl();

    pruefer: Pruefer[] = [];
    idexx_spezies: any[] = [];

    selectedMaterial: Material;
    mengeCtrl = new FormControl(1, [Validators.min(1)]);
    imBefundAnzeigenCtrl = new FormControl(false);
    nichtAbrechnenCtrl = new FormControl(false);
    textCtrl = new FormControl();
    freitextExternCtrl = new FormControl();
    fusszeileCtrl = new FormControl();
    idexx_speziesCtrl = new FormControl();
    idexx_testlaufkommentarCtrl = new FormControl();
    idexx_probenartCtrl = new FormControl();

    befundmitteilungId: string;

    routerSub: Subscription;
    currentClient: Client;
    currentClientParams: HttpParams;
    kundeSearchParams = new HttpParams();
    inaktiveBetriebeAnzeigen = false;

    constructor(
        private route: ActivatedRoute,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private location: Location,
        private befundmitteilungService: BefundmitteilungService,
        private fileUploadService: FileUploadService,
        private pdfViewerService: PdfViewerDesktopService,
        private router: Router,
        private dialog: MatDialog,
        private localStorageService: LocalStorageService,
    ) {
        this.befundmitteilungId = this.route.snapshot.params['id'];
        this.kategorie = this.route.snapshot.queryParams['kategorie'];
    }

    ngOnInit(): void {
        this.currentClient = this.localStorageService.getCurrentClient();
        if (this.currentClient) {
            this.currentClientParams = new HttpParams().set('kunde_id', this.currentClient?.kunde_id);
        }
        this.loadPruefer();
        this.loadBefundmitteilung(this.befundmitteilungId);

        this.routerSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (
                    (this.befundmitteilung?.status_id === 11 || this.befundmitteilung?.status_id === 15) &&
                    this.befundmitteilung?.positionen?.length > 0
                ) {
                    if (this.hasPermission(1313)) {
                        this.saveAndExit();
                    }
                }
            }
        });

        this.api.get(this.apiBaseUrl + 'tierart/read.php', new HttpParams()).subscribe({
            next: response => {
                response.records.forEach(record => {
                    if (record.bezeichnung_eng) {
                        this.idexx_spezies.push(record);
                    }
                });
                this.applyIdexxSpeziesSelection();
            },
            error: err => {
                this.messageService.errorMessage('Tierarten konnten nicht geladen werden!', err);
            },
        });

        this.imBefundAnzeigenCtrl.valueChanges.subscribe(newValue => {
            if (this.currentEditPosition >= 0 && this.currentEditPosition < this.befundmitteilung?.positionen?.length) {
                this.befundmitteilung.positionen[this.currentEditPosition].auflisten = newValue ? 1 : 0;
            }
        });

        this.nichtAbrechnenCtrl.valueChanges.subscribe(newValue => {
            if (this.currentEditPosition >= 0 && this.currentEditPosition < this.befundmitteilung?.positionen?.length) {
                this.befundmitteilung.positionen[this.currentEditPosition].nicht_abrechnen = newValue ? 1 : 0;
            }
        });
    }

    hasPermission(permissionId: number): boolean {
        return this.localStorageService.currentUserHasPermission(permissionId);
    }

    ngOnDestroy() {
        this.routerSub.unsubscribe();
    }

    loadBefundmitteilung(id: string) {
        if (id && id.toLowerCase() === 'neu') {
            this.befundmitteilung = new Befundmitteilung();
            this.befundmitteilung.status_id = 11;
            if (this.kategorien.includes(this.kategorie)) {
                this.befundmitteilung.kategorie = this.kategorie;
            } else {
                this.messageService.alertMessage('Die Kategorie ' + this.kategorie + ' ist nicht gültig!');
            }
            this.initBefundmitteilung();
            return;
        }
        this.api.getOne(this.apiBaseUrl + 'befund/read_one.php', 'befund_id', id).subscribe({
            next: response => {
                this.befundmitteilung = response;
                this.normalizePositionen(this.befundmitteilung?.positionen);
                this.loadAntibiogramme();
                this.initBefundmitteilung();
            },
            error: error => {
                this.messageService.errorMessage(
                    'Der Befund mit der ID ' + id + ' konnte nicht geladen werden!',
                    error,
                );
            },
        });
    }

    initBefundmitteilung() {
        this.loadBefundmitteilungenExtern();

        if (!this.befundmitteilung.eingang) {
            this.befundmitteilung.eingang = new Date();
        }

        if (this.befundmitteilung.gruppe_id) {
            setTimeout(() => {
                const gruppe = new Gruppe();
                gruppe.gruppe_id = this.befundmitteilung.gruppe_id;
                gruppe.bezeichnung = this.befundmitteilung.gruppe;
                gruppe.kunde_id = this.befundmitteilung.kunde_id;
                gruppe.kunde = this.befundmitteilung.kunde;
                const client = new Client();
                client.kunde_id = this.befundmitteilung.kunde_id;
                client.bezeichnung = this.befundmitteilung.kunde;
                client.kunde_nr_intern = this.befundmitteilung.kunde_nr_intern;
                this.currentClient = client;
                this.currentClientParams = new HttpParams().set('kunde_id', this.currentClient?.kunde_id);
                this.currentGruppe = gruppe;
                this.gruppeAutocomplete?.setValue(gruppe, false);
            }, 1000);
        }

        this.probenentnahmeCtrl.setValue(this.befundmitteilung?.probenentnahme);
        this.untersuchungsbeginnCtrl.setValue(this.befundmitteilung?.eingang);
        this.untersuchungsendeCtrl.setValue(this.befundmitteilung?.ausgang);

        this.untersuchungsmaterialCtrl.setValue(this.befundmitteilung?.untersuchungsmaterial);
        this.applyPrueferSelection();
    }

    private applyPrueferSelection(): void {
        if (!this.befundmitteilung?.pruefer_id) {
            return;
        }
        const prueferId = this.befundmitteilung.pruefer_id;
        const fromList = this.pruefer.find(p => KieneUtils.sameId(p.pruefer_id, prueferId));
        if (fromList) {
            this.prueferCtrl.setValue(fromList);
            return;
        }
        const p = new Pruefer();
        p.pruefer_id = prueferId;
        p.bezeichnung = this.befundmitteilung.pruefer;
        this.prueferCtrl.setValue(p);
    }

    loadPruefer() {
        if (!this.localStorageService.currentUserHasPermission(2041)) {
            return;
        }
        this.api.get(this.apiBaseUrl + 'pruefer/read.php').subscribe(response => {
            this.pruefer = response.records;
            this.applyPrueferSelection();
        });
    }

    addFilesToBefundmitteilung(event: Event) {
        this.fileUploadService.openAddFilesDialog(
            this.befundmitteilung.befund_id,
            'befund_id',
            'befund_dokument/create_extern.php',
            () => {
                this.loadBefundmitteilungenExtern();
            },
            () => {
                this.loadBefundmitteilungenExtern();
            },
        );
        event.stopPropagation();
    }

    freigeben() {
        this.befundmitteilung.status_id = 13;
        this.save();
    }

    freigabeEntfernen() {
        this.befundmitteilung.status_id = 11;
        this.save();
    }

    abschliessen() {
        this.befundmitteilung.status_id = 12;
        this.save({ showPdf: true });
    }

    showPdf(befundmitteilung: Befundmitteilung) {
        const input = new PdfViewerDialogInput(
            'befund/read_or_mail_pdf_merged.php',
            new HttpParams().set('befund_id', befundmitteilung?.befund_id?.toString()),
            this.befundmitteilungService.getPdfTitle(befundmitteilung),
            {
                ...this.befundmitteilungService.getPdfViewerEmailOptions(befundmitteilung),
                targetRoute: ['/labor', 'befundmitteilungen'],
            },
        );
        this.pdfViewerService.openPdfViewer(input);
    }

    goBack() {
        this.router.navigate(['../'], { relativeTo: this.route }).then();
    }

    setSelectedMaterial(asse: ArticleScanSelectedEvent) {
        this.selectedMaterial = asse.article;
    }

    setSelectedGruppe(gruppe: Gruppe) {
        this.currentGruppe = gruppe;
    }

    replaceFreitext(event) {
        this.textCtrl.setValue(event);
    }

    replaceUntersuchungsmaterial(event) {
        this.untersuchungsmaterialCtrl.setValue(event);
    }

    replaceFreitextExtern(event) {
        this.freitextExternCtrl.setValue(event);
    }

    replaceFusszeile(event) {
        this.fusszeileCtrl.setValue(event);
    }

    replaceIdexxTestlaufKommentar(event) {
        this.idexx_testlaufkommentarCtrl.setValue(event);
    }

    positionBearbeiten(index: number) {
        if (this.befundmitteilung?.status_id === 12) {
            return;
        }
        this.currentEditPosition = index;

        const p = this.befundmitteilung.positionen[this.currentEditPosition];
        const material = new Material();
        material.artikel_id = p.artikel_id;
        material.artikel_me = p.artikel;
        material.idexx = p.idexx;
        this.articleScan.setMaterial(material, false);
        this.selectedMaterial = material;
        this.mengeCtrl.setValue(p.artikelmenge);
        this.textCtrl.setValue(p.freitext);
        this.freitextExternCtrl.setValue(p.freitext_extern);
        this.imBefundAnzeigenCtrl.setValue(this.isAuflistenChecked(p), { emitEvent: false });
        this.nichtAbrechnenCtrl.setValue(this.isNichtAbrechnenChecked(p), { emitEvent: false });
        this.fusszeileCtrl.setValue(p.fusszeile);
        this.idexx_testlaufkommentarCtrl.setValue(p.idexx_testlaufkommentar);
        this.idexx_probenartCtrl.setValue(p.idexx_probenart);
        this.applyIdexxSpeziesSelection(p.idexx_spezies_tierart_id);
    }

    savePosition() {
        console.log('currentEditPosition', this.currentEditPosition);
        if (this.currentEditPosition > -1) {
            this.befundmitteilung.positionen[this.currentEditPosition].artikel_id = this.selectedMaterial.artikel_id;
            this.befundmitteilung.positionen[this.currentEditPosition].artikel = this.selectedMaterial.artikel_me;
            this.befundmitteilung.positionen[this.currentEditPosition].artikelmenge = this.mengeCtrl.value;
            this.befundmitteilung.positionen[this.currentEditPosition].freitext = this.textCtrl.value;
            this.befundmitteilung.positionen[this.currentEditPosition].freitext_extern = this.freitextExternCtrl.value;
            this.befundmitteilung.positionen[this.currentEditPosition].auflisten = this.imBefundAnzeigenCtrl.value
                ? 1
                : 0;
            this.befundmitteilung.positionen[this.currentEditPosition].nicht_abrechnen = this.nichtAbrechnenCtrl.value
                ? 1
                : 0;
            this.befundmitteilung.positionen[this.currentEditPosition].fusszeile = this.fusszeileCtrl.value;

            this.befundmitteilung.positionen[this.currentEditPosition].idexx_spezies_tierart_id =
                this.idexx_speziesCtrl.value?.tierart_id;
            this.befundmitteilung.positionen[this.currentEditPosition].idexx_spezies =
                this.idexx_speziesCtrl.value?.bezeichnung;
            this.befundmitteilung.positionen[this.currentEditPosition].idexx_probenart = this.idexx_probenartCtrl.value;
            this.befundmitteilung.positionen[this.currentEditPosition].idexx_testlaufkommentar =
                this.idexx_testlaufkommentarCtrl.value;
            this.befundmitteilung.positionen[this.currentEditPosition].idexx = this.selectedMaterial?.idexx;
            this.save();
        } else {
            if (this.selectedMaterial?.artikel_id) {
                this.addPosition();
            }
        }
    }

    clearInputFields() {
        this.mengeCtrl.setValue(null);
        this.imBefundAnzeigenCtrl.setValue(false, { emitEvent: false });
        this.nichtAbrechnenCtrl.setValue(false, { emitEvent: false });
        this.textCtrl.setValue(null);
        this.freitextExternCtrl.setValue(null);
        this.fusszeileCtrl.setValue(null);
        this.articleScan?.clearAndFocus();
        this.currentEditPosition = -1;
        this.idexx_probenartCtrl.reset();
        this.idexx_speziesCtrl.reset();
        this.idexx_testlaufkommentarCtrl.reset();
    }

    addPosition() {
        const position = new BefundmitteilungPosition();
        position.artikel_id = this.selectedMaterial.artikel_id;
        position.artikel = this.selectedMaterial.artikel_me;
        position.artikelmenge = this.mengeCtrl.value;
        position.auflisten = this.imBefundAnzeigenCtrl.value ? 1 : 0;
        position.nicht_abrechnen = this.nichtAbrechnenCtrl.value ? 1 : 0;
        position.freitext = this.textCtrl.value;
        position.freitext_extern = this.freitextExternCtrl.value;
        position.fusszeile = this.fusszeileCtrl.value;
        position.idexx_testlaufkommentar = this.idexx_testlaufkommentarCtrl.value;
        position.idexx_probenart = this.idexx_probenartCtrl.value;
        position.idexx_spezies_tierart_id = this.idexx_speziesCtrl.value?.tierart_id;
        position.idexx_spezies = this.idexx_speziesCtrl.value?.bezeichnung;
        this.befundmitteilung.positionen.push(position);
        // this.clearInputFields();
        this.save();
    }

    prueferComparator = (p1: Pruefer, p2: Pruefer) => KieneUtils.sameId(p1?.pruefer_id, p2?.pruefer_id);

    idexxSpeziesComparator = (a: { tierart_id?: unknown }, b: { tierart_id?: unknown }) =>
        KieneUtils.sameId(a?.tierart_id, b?.tierart_id);

    isIdexxMaterial(): boolean {
        return Number(this.selectedMaterial?.idexx) === 1;
    }

    private applyIdexxSpeziesSelection(tierartId?: unknown): void {
        const id =
            tierartId ??
            this.befundmitteilung?.positionen?.[this.currentEditPosition]?.idexx_spezies_tierart_id;
        if (!id) {
            return;
        }
        const fromList = this.idexx_spezies.find(o => KieneUtils.sameId(o.tierart_id, id));
        if (fromList) {
            this.idexx_speziesCtrl.setValue(fromList);
        }
    }

    save(options?: { exit?: boolean; showPdf?: boolean }) {
        this.disableFormControls();
        if (!this.befundmitteilung.kategorie) {
            this.enableFormControls();
            this.messageService.alertMessage(
                'Der Befund kann nicht gespeichert werden, da keine Kategorie ausgewählt wurde!',
            );
            return;
        }
        this.befundmitteilung.probenentnahme = this.probenentnahmeCtrl.value;
        this.befundmitteilung.eingang = this.untersuchungsbeginnCtrl.value;
        this.befundmitteilung.ausgang = this.untersuchungsendeCtrl.value;
        this.befundmitteilung.gruppe_id = this.currentGruppe?.gruppe_id;
        this.befundmitteilung.untersuchungsmaterial = this.untersuchungsmaterialCtrl.value;
        this.befundmitteilung.kunde_id = this.currentClient?.kunde_id;
        const pruefer: Pruefer = this.prueferCtrl.value;
        if (pruefer) {
            this.befundmitteilung.pruefer_id = pruefer.pruefer_id;
        }

        // Flags als 0/1 (kein boolean) – gibInt in der DB akzeptiert nur Ziffern-Strings
        this.normalizePositionen(this.befundmitteilung?.positionen);

        this.api.updateEntity(this.apiBaseUrl + 'befund/update.php', this.befundmitteilung).subscribe({
            next: response => {
                this.befundmitteilung = response;
                this.normalizePositionen(this.befundmitteilung?.positionen);
                this.applyPrueferSelection();
                this.clearInputFields();
                this.enableFormControls();
                this.messageService.infoMessage('Befundmitteilung wurde erfolgreich gespeichert!');
                if (options?.showPdf === true) {
                    this.showPdf(response);
                }
                if (options?.exit === true) {
                    this.goBack();
                }
                const url = this.location
                    .path()
                    .replace('befundmitteilungen/neu', 'befundmitteilungen/' + this.befundmitteilung.befund_id);
                this.location.replaceState(url);
            },
            error: error => {
                this.enableFormControls();
                this.messageService.errorMessage('Befundmitteilung konnte nicht gespeichert werden!', error);
            },
        });
    }

    saveAndExit() {
        if (this.befundmitteilung?.status_id === 12) {
            this.goBack();
        } else {
            // 1313: Labor - Befundmitteilung - editieren
            if (
                this.hasPermission(1313) ||
                (!this.befundmitteilung.befund_id && this.befundmitteilung?.positionen.length > 0)
            ) {
                this.save({ exit: true });
            } else {
                this.goBack();
            }
        }
    }

    positionEntfernen(index: number) {
        this.befundmitteilung.positionen.splice(index, 1);
        this.save();
    }

    loadBefundmitteilungenExtern() {
        if (!this.befundmitteilung.befund_id) {
            return;
        }
        this.befundmitteilungService.getPdfIdsForBefundmitteilung(this.befundmitteilung.befund_id).subscribe({
            next: response => {
                this.befundmitteilungenExtern = response.records;
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    openPdfPreview(event: Event) {
        event.stopPropagation();

        const input = new PdfViewerDialogInput(
            'befund/pdf_vorschau.php',
            null,
            'Vorschau Befundmitteilung ' + this.befundmitteilung.tagebuch_nr,
        );
        input.object = this.befundmitteilung;
        this.pdfViewerService.openPdfViewer(input);
    }

    uploadExterneBefundmitteilung(files: File[]) {
        this.fileUploadService.uploadFilesToServer(
            files,
            'befund_id',
            this.befundmitteilung.befund_id,
            'befund_dokument/create_extern.php',
        );
        this.fileUploadService.watchFileUploaded().subscribe(fileName => {
            for (const f of files) {
                if (f.name === fileName) {
                    this.loadBefundmitteilungenExtern();
                }
            }
        });
    }

    openExterneBefundeDialog() {
        this.dialog.open(ExterneBefundeDialogComponent, {
            data: { externeBefunde: this.befundmitteilungenExtern, befundmitteilung: this.befundmitteilung },
        })
        .afterClosed()
        .subscribe(() => {
            // Nach dem Schließen des Dialogs die Liste neu laden
            this.loadBefundmitteilungenExtern();
        });
    }

    dropPosition(event: CdkDragDrop<BefundmitteilungPosition[]>) {
        if (this.befundmitteilung?.status_id === 12) {
            return;
        }
        moveItemInArray(this.befundmitteilung.positionen, event.previousIndex, event.currentIndex);
        this.reorderPositionNumbers();
        this.save();
    }

    reorderPositionNumbers() {
        for (let i = 0; i < this.befundmitteilung.positionen.length; i++) {
            this.befundmitteilung.positionen[i].position = i + 1;
        }
    }

    transformToAntibiogramm() {
        this.api.post(this.apiBaseUrl + 'antibiogramm/transform.php', this.befundmitteilung, null).subscribe({
            next: response => {
                this.router
                    .navigate(['../../antibiogramme', response.antibiogramm_id], { relativeTo: this.route })
                    .then();
            },
            error: err => {
                this.messageService.errorMessage('Antibiogramm konnte nicht erstellt werden! ', err);
            },
        });
    }

    getTestlaufStatus(): boolean {
        return Number(this.befundmitteilung.positionen[this.currentEditPosition]?.abgeschlossen) === 1;
    }

    isIdexxPosition(p: BefundmitteilungPosition): boolean {
        return Number(p?.idexx) === 1;
    }

    isAbgeschlossen(p: BefundmitteilungPosition): boolean {
        return Number(p?.abgeschlossen) === 1;
    }

    openResultDialog(position: BefundmitteilungPosition) {
        this.dialog.open(IdexxResultDialogComponent, { data: { befundeArtikelId: position.ba_id } });
    }

    setSelectedClient(client: Client) {
        this.currentClient = client;
        if (!client) {
            this.currentGruppe = undefined;
            this.currentClientParams = undefined;
            this.gruppeAutocomplete.clear();
        } else {
            this.currentClientParams = new HttpParams().set('kunde_id', this.currentClient?.kunde_id);
            setTimeout(() => {
                this.gruppeAutocomplete?.clearAndFocus();
            }, 100);
        }
    }

    inaktiveBetriebeAnzeigenChanged(event: MatCheckboxChange) {
        this.inaktiveBetriebeAnzeigen = event.checked;
        if (this.inaktiveBetriebeAnzeigen) {
            this.kundeSearchParams = new HttpParams().set('inaktiv', '1');
        } else {
            this.kundeSearchParams = new HttpParams();
        }
    }

    isClientDisabled() {
        return !!this.befundmitteilung?.rechnung_id;
    }

    public toggleAuflisten(p: BefundmitteilungPosition): void {
        p.auflisten = this.isAuflistenChecked(p) ? 0 : 1;
        if (
            this.currentEditPosition >= 0 &&
            this.befundmitteilung?.positionen?.[this.currentEditPosition] === p
        ) {
            this.imBefundAnzeigenCtrl.setValue(this.isAuflistenChecked(p), { emitEvent: false });
        }
        this.save();
    }

    public toggleNichtAbrechnen(p: BefundmitteilungPosition): void {
        p.nicht_abrechnen = this.isNichtAbrechnenChecked(p) ? 0 : 1;
        if (
            this.currentEditPosition >= 0 &&
            this.befundmitteilung?.positionen?.[this.currentEditPosition] === p
        ) {
            this.nichtAbrechnenCtrl.setValue(this.isNichtAbrechnenChecked(p), { emitEvent: false });
        }
        this.save();
    }

    /** API liefert Flags oft als String ("0"/"1") – KieneUtils.isApiOne. */
    isAuflistenChecked(p: BefundmitteilungPosition): boolean {
        return KieneUtils.isApiOne(p?.auflisten);
    }

    isNichtAbrechnenChecked(p: BefundmitteilungPosition): boolean {
        return KieneUtils.isApiOne(p?.nicht_abrechnen);
    }

    private normalizePositionen(positionen?: BefundmitteilungPosition[]): void {
        positionen?.forEach(p => {
            p.auflisten = KieneUtils.isApiOne(p.auflisten) ? 1 : 0;
            p.nicht_abrechnen = KieneUtils.isApiOne(p.nicht_abrechnen) ? 1 : 0;
            if (p.idexx != null) {
                p.idexx = KieneUtils.isApiOne(p.idexx) ? 1 : 0;
            }
        });
    }

    public resetPosition(): void {
        this.clearInputFields();
    }

    public openPreisAnpassungDialog(p: BefundmitteilungPosition): void {
        if (this.hasPermission(1285)) {
            if (this.befundmitteilung?.status_id === 11 || this.befundmitteilung?.status_id === 13) {
                const preisAnpassungInput = new PreisAnpassungInput();
                preisAnpassungInput.ba_id = p.ba_id;
                preisAnpassungInput.einzelpreis = p?.einzelpreis;
                preisAnpassungInput.artikel = p?.artikel;

                this.dialog
                    .open(PreisAnpassungDialogComponent, { data: preisAnpassungInput })
                    .afterClosed()
                    .subscribe({
                        next: (result: PreisAnpassungResult) => {
                            if (result?.confirm) {
                                this.loadBefundmitteilung(this.befundmitteilungId);
                            }
                        },
                    });
            }
        }
    }

    openAntibiogramm(event: MatSelectChange) {
        if (event?.value) {
            const id = event.value?.antibiogramm_id;
            if (id) {
                this.router.navigate(['../../antibiogramme', id], { relativeTo: this.route }).then();
            }
        }
    }

    kategorieBearbeiten() {
        if (this.befundmitteilung?.rechnung_id || this.befundmitteilung?.status_id === 12) {
            return;
        }
        this.dialog
            .open(SelectBefundKategorieDialogComponent, {
                data: {
                    title: 'Kategorie auswählen',
                    text: 'Bitte wählen Sie eine Kategorie aus.',
                    buttonText: 'Auswählen',
                },
            })
            .afterClosed()
            .subscribe({
                next: kategorie => {
                    if (kategorie) {
                        this.kategorie = kategorie;
                        this.befundmitteilung.kategorie = kategorie;
                        this.save();
                    }
                },
            });
    }

    private loadAntibiogramme() {
        const params = new HttpParams().set('befund_id', this.befundmitteilung?.befund_id?.toString());
        this.api.get(this.apiBaseUrl + 'antibiogramm/read.php', params).subscribe({
            next: response => {
                this.antibiogramme = response.records;
            },
            error: err => {
                this.messageService.errorMessage('Antibiogramme konnten nicht geladen werden!', err);
            },
        });
    }

    private disableFormControls() {
        this.probenentnahmeCtrl.disable();
        this.untersuchungsbeginnCtrl.disable();
        this.untersuchungsendeCtrl.disable();
        this.untersuchungsmaterialCtrl.disable();
        this.prueferCtrl.disable();
        this.mengeCtrl.disable();
        this.imBefundAnzeigenCtrl.disable();
        this.nichtAbrechnenCtrl.disable();
        this.textCtrl.disable();
        this.freitextExternCtrl.disable();
        this.fusszeileCtrl.disable();
        this.idexx_speziesCtrl.disable();
        this.idexx_testlaufkommentarCtrl.disable();
        this.idexx_probenartCtrl.disable();
        this.antibiogrammCtrl.disable();
    }

    private enableFormControls() {
        this.probenentnahmeCtrl.enable();
        this.untersuchungsbeginnCtrl.enable();
        this.untersuchungsendeCtrl.enable();
        this.untersuchungsmaterialCtrl.enable();
        this.prueferCtrl.enable();
        this.mengeCtrl.enable();
        this.imBefundAnzeigenCtrl.enable();
        this.nichtAbrechnenCtrl.enable();
        this.textCtrl.enable();
        this.freitextExternCtrl.enable();
        this.fusszeileCtrl.enable();
        this.idexx_speziesCtrl.enable();
        this.idexx_testlaufkommentarCtrl.enable();
        this.idexx_probenartCtrl.enable();
        this.antibiogrammCtrl.enable();
    }
}
